/**
 * Team documentation the console links to. Canonical Confluence URLs only
 * (the `spaces/<KEY>/pages/<id>/<title>` form): the short `/wiki/pages/<id>`
 * form does not route.
 */
export const CLIP_LIFECYCLE_DOC_URL =
  'https://jirafilter.atlassian.net/wiki/spaces/Product/pages/101056513/Clip+lifecycle+stages+and+what+each+cleanup+does+to+them';

export const CLIP_LIFECYCLE_DOC_TITLE =
  'What each Clip stage means (activated, registered, in inventory…) and what each Data Cleanup action does to it';
